import { storage } from '../../utils/storage';
import { BaseApiService } from './baseApiService';

interface ChatMessage {
  role: string | undefined;
  transcript: string | undefined;
}

interface PatientInfo {
  name: string;
  age: number;
  gender: string;
}

interface PatientUpdateRequest {
  name: string;
  age: number;
  dateOfBirth: string;
  gender: string;
}


class ChatService extends BaseApiService {
  async sendChatHistory(messages: ChatMessage[]): Promise<void> {
    const validMessages = messages.filter(msg => 
      msg.role !== undefined && msg.transcript !== undefined
    ).map(msg => ({
      role: msg.role as string,
      transcript: msg.transcript as string
    }));

    const authData = storage.getAuthData();
    const sessionId = authData?.session?.magic_link_session_id || authData?.session?.id;

    const encryptedData = this.encrypt({
      messages: validMessages,
      session_id: sessionId
    });

    await this.fetchWithAuth('/chat/message/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: encryptedData,
    });
  }

  async updatePatientInfo(data: PatientUpdateRequest): Promise<void> {
    try {
      const authData = storage.getAuthData();

      console.log("AUTH DATA",authData)
      if (!authData?.user?.id) {
        throw new Error('User ID not found');
      }

      const response = await this.fetchWithAuth(
        `/analysis/patient/${authData.user.id}/`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            preferred_name: data.name,
            age: data.age,
            date_of_birth: data.dateOfBirth,
            gender: data.gender,
          }),
        }
      );

      // Simple response check
      if (response.status !== 'success') {
        throw new Error(`API error: ${response.message || 'Unknown error'}`);
      }

    } catch (error) {
      console.error('Update patient info error:', error);
      // Don't throw the error, just log it
      // This prevents the error from propagating and causing a logout
    }
  }

  async getChatbotSession(patientData: { patient_name: string; patient_age: string; patient_gender: string; specialty?: string }): Promise<any> {
    return this.fetchWithAuth('/chatbot/session/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(patientData)
    });
  }
}

export const chatService = new ChatService(); 